module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Sett ditt<br> daglige mål","label":"Hjernedates"},"en":{"title":"Set your<br> daily goal","label":"Brain dates"}}')
  delete Component.options._Ctor
}
